import React from 'react';
import Subtopics from './Subtopics';
import { Container } from "react-bootstrap";
import {
    Switch,
    Route,
    Link,
    useRouteMatch
  } from "react-router-dom";

function ControlSystems(props) {
    let { path, url } = useRouteMatch();
    return (
        <div>
            <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh', maxWidth: "100vw"}}>
                {/* <SectionTitle title={props.topicId}/> */}
            <div style={{display: 'flex', flexDirection: 'row'}}> 
            <div style={{marginTop: '10px', marginRight: '0px', marginLeft: '5px',border: '3px', padding:'40px', paddingRight: '50px', borderStyle:'solid', borderColor:'grey', paddingLeft: '20px', whiteSpace:'nowrap'}}>
                <h2>Control Systems</h2>
                <li>
                    <Link to={`${url}/blockdiagrams`}>Overview & Block Diagrams</Link>
                </li>
                           <li>
                    <Link to={`${url}/systemmodeling`}>System Modeling</Link>
                </li>
                       <li>
                    <Link to={`${url}/linearization`}>Linearization</Link>
                </li>
                       <li>
                    <Link to={`${url}/firstorderresponse`}>First & Second Order Response</Link>
                </li>
                       <li>
                    <Link to={`${url}/steadystateerror`}>Steady State Error</Link>
                </li>
                       <li>
                    <Link to={`${url}/pidcontrol`}>PID Control & Tuning</Link>
                </li>
                       <li>
                    <Link to={`${url}/cascadecontrol`}>Cascade & Feedforward Control</Link>
                </li>
                       <li>
                    <Link to={`${url}/bodeplots`}>Bode Plots</Link>
                </li>
                       <li>
                    <Link to={`${url}/nyquistcriterion`}>Nyquist Criterion</Link>
                </li>
                       <li>
                    <Link to={`${url}/gainandphase`}>Gain & Phase Margin</Link>
                </li>
                       <li>
                    <Link to={`${url}/rootlocus`}>Root Locus Method</Link>
                </li>
                       <li>
                    <Link to={`${url}/statespace`}>State-Space Modeling</Link>
                </li>
                       <li>
                    <Link to={`${url}/controllability`}>Controllability & Observability</Link>
                </li>
                       <li>
                    <Link to={`${url}/statefeedback`}>State Feedback & Pole Placement</Link>
                </li>
                       <li>
                    <Link to={`${url}/luenbergerobserver`}>Luenberger Observer</Link>
                </li>
                       <li>
                    <Link to={`${url}/kalmanfilter`}>Kalman Filter</Link>
                </li>
                       <li>
                    <Link to={`${url}/predictivecontrol`}>Model Predictive Control</Link>
                </li>
                 <li>
                    <Link to={`${url}/adaptivecontrol`}>Adaptive & Robust Control</Link>
                </li>
                </div>
                
            <Container>
                <Switch>
                    <Route exact path={path}>
                    <h3>Please select a sub-topic.</h3>
                    </Route>
                    <Route path={`${path}/:topicId`}>
                        <Subtopics />
                    </Route>
                </Switch>
            </Container>
         
                    </div>
            </div>
        </div>
    );
};

export default ControlSystems; 